export { Tag, renderTag, useTag, useTagContextValues } from './components/Tag';
export type { TagSlots, TagProps, TagState, TagContextValues } from './components/Tag';
